/**
 * Created by katarinababic on 23.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { WeaviateSuggestionResult } from '../../Model/Suggestions/WeaviateSuggestionResult';
import { HomeScreenMentalSuggestionItem } from './HomeScreenMentalSuggestionItem';
import { HomeScreenRecipeSuggestionItem } from './HomeScreenRecipeSuggestionItem';
import { HomeScreenFitnessSuggestionItem } from './HomeScreenFitnessSuggestionItem';

export type HomeScreenSuggestionsRendererSwitchProps = {
  suggestion: WeaviateSuggestionResult;
  onRefresh?: () => void;
};

export const HomeScreenSuggestionsRendererSwitch: React.FC<HomeScreenSuggestionsRendererSwitchProps> = observer(
  ({ suggestion, onRefresh }) => {
    if (suggestion.category === 'mental') {
      return <HomeScreenMentalSuggestionItem suggestion={suggestion} onRefresh={onRefresh} />;
    } else if (suggestion.category === 'nutrition') {
      return <HomeScreenRecipeSuggestionItem suggestion={suggestion} onRefresh={onRefresh} />;
    }
    return <HomeScreenFitnessSuggestionItem suggestion={suggestion} onRefresh={onRefresh} />;
  },
);
